import React from 'react'

class Desserts extends React.Component {
    constructor(props){
        super(props)
        this.state = {
            desserts: ''
        }
    }
    getPrice = (number) => {
        let price = parseFloat(number)
        return price
    }
    getDessertMenu = () => {
        const dessertMenuId = '604a819b88b21f0999b915d3'
        const url = `https://beta.pizzaluce.com/api/menu/${dessertMenuId}/full`

        fetch(url)
        .then(res => res.json())
        .then(data => {
            console.log(data)
            let dessertSpecial = {
                
            }
            return data
        })
        .then(data => this.setState({desserts: data[0]}))
        .catch(err => err)
    }
    componentDidMount(){
        console.log('dessert page load')
        this.getDessertMenu()
    }
    getDesserts = () => {        
            return (
                <>
                <div className="dessert-container">
                    
                    {this.state.desserts 
                        ?   this.state.desserts.sections[0].items.map(item => (
                            
                                <div className="dessert-item">
                                    <div className="dessert-item-title">
                                        {item.name.label} • <span>{this.getPrice(item.prices[0].amount)}</span>
                                    </div>
                                    <div className="dessert-item-description">
                                        {item.description[0].description_text}
                                    </div>
                                </div>
                            ))

                        :   <div></div>
                    }
                </div>
                <div className="dessert-container-right">
                    
                {this.state.desserts 
                    ?   this.state.desserts.sections[0].items.map(item => (
                        
                            <div className="dessert-item">
                                <div className="dessert-item-title">
                                    {item.name.label} • <span>{this.getPrice(item.prices[0].amount)}</span>
                                </div>
                                <div className="dessert-item-description">
                                    {item.description[0].description_text}
                                </div>
                            </div>
                        ))

                    :   <div></div>
                }
            </div>
            </>
            )
    }
    render(){
        console.log('dessert page')
        return (
            <div className="dessert-dessert-page-two-column">
                <div className="dessert-left-column">
                    {this.getDesserts()} 
                </div>
               
            </div>
        )
    }
    
}
export default Desserts